import { Component } from '@angular/core';

@Component({
  selector: 'additional-software',
  templateUrl: './additional-software.component.html',
  styleUrls: ['./additional-software.component.scss']
})
export class AdditionalSoftwareComponent {

}
